
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class BusinessCard extends Vue {
  businessAddress: string = process.env.VUE_APP_BUSINESS_ADDRESS
  businessPhone: string = process.env.VUE_APP_BUSINESS_PHONE
  businessSocialMedia = {
    facebook: process.env.VUE_APP_BUSINESS_FACEBOOK,
    instagram: process.env.VUE_APP_BUSINESS_INSTAGRAM,
    linkedin: process.env.VUE_APP_BUSINESS_LINKEDIN,
    tripadvisor: process.env.VUE_APP_BUSINESS_TRIPADVISOR,
  }
}
